export default __webpack_public_path__ + "static/media/AkkuratLLWeb-Regular.16f2e5fb.woff";